export default __webpack_public_path__ + "static/media/amex.376b7521.png";